export default __webpack_public_path__ + "static/media/chevron-up-mint.1ba0c2ce.svg";